import React from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { Colours } from '../../tokens';
import SVG from '../SVG';
const useStyles = createUseStyles({
    root: {
        color: Colours.primary,
    },
});
function PlusSquareIcon({ className }) {
    const styles = useStyles();
    return (React.createElement(SVG, { width: "24", height: "24", viewBox: "0 0 24 24", className: classNames(styles.root, className) },
        React.createElement("g", { transform: "translate(-620 -318)" },
            React.createElement("path", { d: "M6.3,18h5.4c4.5,0,6.3-1.8,6.3-6.3V6.3C18,1.8,16.2,0,11.7,0H6.3C1.8,0,0,1.8,0,6.3v5.4C0,16.2,1.8,18,6.3,18Z", transform: "translate(623 321)", fill: "none", stroke: "currentColor", strokeWidth: "1.5" }),
            React.createElement("path", { d: "M0,0H24V24H0Z", transform: "translate(620 318)", fill: "none" }),
            React.createElement("path", { d: "M0,0H5.938", transform: "translate(629.031 330)", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5" }),
            React.createElement("path", { d: "M0,5.938V0", transform: "translate(632 327.031)", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5" }))));
}
export default PlusSquareIcon;
//# sourceMappingURL=PlusSquareIcon.js.map